"use client";

import { useRef, useEffect } from "react";

/**
 * Store the previous value of variable
 * @function usePrev
 * @param {T} value previous value
 * @returns {T}
 */
export const usePrev = <T,>(value: T): T => {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
export default usePrev;